import React, {Component, useEffect} from "react";

import {
	Button,
	Col,
	Descriptions,
	Dropdown,
	List,
	Menu as AntdMenu,
	message,
	Radio,
	Row,
	Select,
	Space,
	Spin,
	Statistic,
	Steps,
	Tag,
} from "antd";
import {useForm} from "antd/es/form/Form";

import {labels} from "./ItemsListTable";
import api from "../../api";
import {FilterRepresentation} from "../exception-reporting/ExceptionReporting";
import {arrayOptions, dateOptions, numberOptions, stringOptions} from "../helpers/AdvancedFIlter";
import {DataCard} from "../helpers/cards/Card";
import {StandardForm} from "../helpers/forms/StandardForm";
import {ModalWindow} from "../helpers/modals/ModalWindow";

function MaterialFilter(props) {
	const [fields, setFields] = React.useState([]);
	const [total, setTotal] = React.useState(0);
	const [selected, setSelected] = React.useState({});
	const [proposedValues, setProposedValues] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [mode, setMode] = React.useState({});
	const [isEdit, setEdit] = React.useState(false);
	const [filter, setFilter] = React.useState(null);
	const [criteria, setCriteria] = React.useState({or: {}});

	const getFields = () => {
		setLoading(true);
		api.get(`/projects/${props.projectId}/materials/attributes`)
			.then(json => setFields(json.data))
			.finally(() => setLoading(false));
	};

	const getOptionsByType = () => {
		if (selected.type === "text") {
			return stringOptions;
		} else if (selected.type === "number") {
			return numberOptions;
		} else if (selected.type === "array") {
			return arrayOptions;
		} else if (selected.type === "date") {
			return dateOptions;
		}
		return [];
	};

	const getProposedValues = () => {
		if (selected.field !== "long_description") {
			setLoading(true);
			api.get(`/projects/${props.projectId}/materials/attributes/values?attr=${selected.field}`)
				.then(json => {
					setProposedValues(json.data);
				})
				.finally(() => setLoading(false));
		}
	};

	useEffect(() => {
		getFields();
	}, [props.projectId]);

	useEffect(() => {}, [props.criteria]);

	useEffect(() => {
		if (selected.field && filter && selected.field === filter.key) {
			getProposedValues();
		} else if (selected.field) {
			getProposedValues();
			setMode(getDefaultMode());
		}
	}, [selected]);

	useEffect(() => {
		setSelected({});
		attrValueForm.resetFields(["name", "value"]);
	}, [props.filters]);

	const [attrValueForm] = useForm();

	const getDefaultMode = (_selected = selected) => {
		if (_selected.type === "text") {
			return "full";
		} else if (_selected.type === "number") {
			return "eq";
		} else if (_selected.type === "array") {
			return "full";
		} else if (_selected.type === "date") {
			return "eq";
		}
		return "";
	};

	const getValuesFields = () => {
		if (selected.type === "date") {
			return [
				{
					label: "Attribute Value",
					name: "value",
					_type: "date",
				},
			];
		} else if (mode === "in") {
			return [
				{
					label: "Attribute Value",
					name: "value",
					_type: "select-tag",
					options: proposedValues.map(v => ({
						value: v,
						label: String(v),
					})),
				},
			];
		}

		return [{label: "Attribute Value", name: "value", _type: "autocomplete", options: proposedValues}];
	};

	const deleteFilter = attr => {
		const filts = {...props.filters};
		for (const query of filts["or"]) {
			query["and"] = query["and"].filter(
				x => !(x.key === attr.key && x.value === attr.value && x.mode === attr.mode),
			);
		}

		const data = {or: []};
		for (const clause of filts["or"]) {
			if (clause["and"].length > 0) {
				data["or"].push(clause);
			}
		}

		if (data["or"].length === 0) {
			data["or"].push({and: []});
		}

		props.onFilterChange(data);
		setEdit(false);
		setFilter(null);
	};

	const addFilter = (position, idx = 0) => {
		let value = attrValueForm.getFieldValue("value");
		if (selected.type === "date") {
			if (value === undefined) {
				value = new Date();
			} else {
				value = value.toDate();
			}
		}

		const filters = props.filters;

		if (isEdit) {
			for (const query in filters["or"]) {
				if (
					filters["or"][query]["and"].find(
						x => x.key === filter.key && x.mode === filter.mode && x.value === filter.value,
					)
				) {
					filters["or"][query]["and"] = filters["or"][query]["and"].filter(
						x => !(x.key === filter.key && x.mode === filter.mode && x.value === filter.value),
					);
					filters["or"][query]["and"].push({
						key: selected.field,
						value: value,
						mode: mode,
						type: selected.type,
					});
					setEdit(false);
					setFilter(null);
				}
			}
			// filters = filters.filter(x => !(x.key === filter.key && x.mode === filter.mode && x.value === filter.value) );
		} else {
			if (position === "and") {
				filters["or"][idx]["and"].push({
					key: selected.field,
					value: value,
					mode: mode,
					type: selected.type,
				});
			} else if (position === "or") {
				filters["or"].push({
					and: [
						{
							key: selected.field,
							value: value,
							mode: mode,
							type: selected.type,
						},
					],
				});
			}
		}

		props.onFilterChange({...filters});
	};

	const getFilterRepresentation = (criteria = props.filters) => {
		const getTagColor = condition => {
			switch (condition) {
				case "and":
					return "purple";
				case "or":
					return "cyan";
				default:
					return "white";
			}
		};
		if (!criteria || !criteria["or"]) {
			return <div>Scope criteria wasn't saved!</div>;
		} else {
			const blocks = [];
			for (const x of criteria["or"]) {
				if (Array.isArray(x)) {
					blocks.push(
						<Tag style={{padding: 10, display: "block"}}>
							<FilterRepresentation
								break={true}
								filters={x}
								labels={{...labels}}
								deleteFilter={editFilter}
							/>
						</Tag>,
					);
				} else {
					for (const cond in x) {
						const title = x[cond].length > 1 ? <div>And</div> : <div />;
						if (x[cond] && x[cond].length > 0) {
							blocks.push(
								<Row style={{padding: 5}}>
									<Tag icon={title} color={getTagColor(cond)} style={{padding: 10}}>
										<FilterRepresentation
											breakLines={true}
											filters={x[cond]}
											labels={{...labels}}
											deleteFilter={editFilter}
										/>
									</Tag>
								</Row>,
							);
						}
					}
				}
			}

			return (
				<Tag style={{padding: 10}} color={"magenta"} icon={<div>Or</div>}>
					{blocks}
				</Tag>
			);
		}
	};

	const editFilter = filter => {
		const attr = fields.find(x => x.field === filter.key);
		setFilter(filter);
		if (attr) {
			setEdit(true);
			setSelected(attr);
			setMode(filter.mode);
			attrValueForm.setFieldValue("value", filter.value);
		}
	};

	const getSuffix = idx => {
		if (idx === 1) {
			return "st";
		} else if (idx === 2) {
			return "nd";
		} else if (idx === 3) {
			return "rd";
		}
		return "th";
	};

	const getDropdownMenu = () => {
		const current = props.filters["or"];

		const options = [];

		if (current.length > 0 && current[0]["and"].length !== 0) {
			options.push(
				<AntdMenu.Item key={"or"} onClick={() => addFilter("or")}>
					Add as an <b>Or</b> clause
				</AntdMenu.Item>,
			);
		}

		for (const clause in current) {
			options.push(
				<AntdMenu.Item key={`and-${clause}`} onClick={() => addFilter("and", clause)}>
					Add to {parseInt(clause) + 1}
					{getSuffix(parseInt(clause) + 1)} <b>And</b> clause
				</AntdMenu.Item>,
			);
		}

		return <AntdMenu>{options}</AntdMenu>;
	};

	return (
		<div style={{margin: 10}}>
			<Spin spinning={loading}>
				<Descriptions size={"small"} style={{width: "100%", margin: 5}} bordered column={2}>
					<Descriptions.Item labelStyle={{width: "20%"}} label={"Items in current selection"}>
						<Statistic valueStyle={{fontSize: 16}} value={props.total} />
					</Descriptions.Item>
					<Descriptions.Item labelStyle={{width: "20%"}} label={"Current Filters"}>
						<Statistic valueStyle={{fontSize: 16}} value={props.filters.length} />
					</Descriptions.Item>
				</Descriptions>
				<Row style={{marginTop: 5}}>
					<Col span={7} style={{margin: 5}}>
						<DataCard
							title="Attributes"
							style={{
								maxHeight: "61vh",
								overflow: "scroll",
							}}>
							<List
								size="small"
								bordered
								style={{padding: 0, margin: -10}}
								dataSource={fields}
								renderItem={item => (
									<List.Item
										className={
											selected.label === item.label ? "ant-dropdown-menu-item-selected" : ""
										}
										onClick={() => {
											setSelected(item);
											setFilter(null);
											setEdit(false);
											attrValueForm.resetFields(["value"]);
										}}>
										{item.label}
									</List.Item>
								)}
							/>
						</DataCard>
					</Col>
					<Col span={8} style={{margin: 5}}>
						{selected.label && (
							<DataCard
								title={
									<div>
										Attribute: <b>{selected.label}</b>
									</div>
								}>
								{selected && selected.field && (
									<StandardForm
										form={attrValueForm}
										fields={getValuesFields()}
										onFinish={val => console.log(val)}
									/>
								)}
								{selected && selected.field && getOptionsByType().length > 0 && (
									<Space>
										<Radio.Group
											style={{margin: 10}}
											onChange={e => setMode(e.target.value)}
											value={mode}>
											<Space direction={"vertical"}>
												Search Mode:
												{getOptionsByType().map((item, i) => (
													<Radio value={item.value}>{item.label}</Radio>
												))}
											</Space>
										</Radio.Group>
									</Space>
								)}
								<Row>
									<Col span={8}>
										{isEdit && (
											<Button type={"danger"} onClick={() => deleteFilter(filter)}>
												Delete
											</Button>
										)}
									</Col>
									<Col span={16}>
										{isEdit ? (
											<Button onClick={addFilter} type={"primary"}>
												Save
											</Button>
										) : (
											<Dropdown className="float-right" overlay={getDropdownMenu()}>
												<Button type={"primary"}>Add</Button>
											</Dropdown>
										)}
									</Col>
								</Row>
							</DataCard>
						)}
					</Col>
					<Col span={8} style={{margin: 5}}>
						<DataCard title="Filters">{getFilterRepresentation()}</DataCard>
					</Col>
				</Row>
			</Spin>
		</div>
	);
}

function ScopeMode(props) {
	const [mode, setMode] = React.useState("new");
	const [loading, setLoading] = React.useState(false);
	const [scopes, setScopes] = React.useState([]);

	const copy = () => {
		if (scopes.length === 0) {
			setLoading(true);
			api.post(`/projects/${props.projectId}/scopes`, {_filters: {}, _query: ""})
				.then(json => {
					setScopes(json.data.items);
					props.onScopeSelect(0, json.data.items[0]);
				})
				.finally(() => setLoading(false));
		}
	};

	const options = [
		{
			label: "Create filters from scratch",
			value: "new",
			onClick: () => {
			    props.resetChoice();
			    props.openNext("new");
			}
		},
		{
			label: "Copy filters from another scope",
			value: "copy",
			onClick: () => copy(),
		},
	];

	return (
		<DataCard style={{margin: 10}} title={"Select what do you want to do: "}>
			<Spin spinning={loading}>
				<Radio.Group style={{margin: 10}} onChange={e => setMode(e.target.value)} value={mode}>
					<Space direction="vertical">
						{options.map((item, i) => (
							<Radio onClick={item.onClick} value={item.value}>
								{item.label}
							</Radio>
						))}
					</Space>
				</Radio.Group>
				<div>
					{mode === "copy" && (
						<Select
							style={{width: 500}}
							value={props.selected}
							onChange={idx => props.onScopeSelect(idx, scopes[idx])}
							options={scopes.map((item, idx) => ({
								label: item.name,
								value: idx,
							}))}
						/>
					)}
				</div>
			</Spin>
		</DataCard>
	);
}

function AddToScope(props) {
	const [mode, setMode] = React.useState("new");
	const [loading, setLoading] = React.useState(false);

	const [scopes, setScopes] = React.useState([]);
	const [selected, setSelected] = React.useState();

	const copy = () => {
		if (scopes.length === 0) {
			setLoading(true);
			api.post(`/projects/${props.projectId}/scopes`, {_filters: {}, _query: ""})
				.then(json => {
					setScopes(json.data.items);
					setSelected(0);
				})
				.finally(() => setLoading(false));
		}
	};

	const options = () => {
		const _options = [
			{
				label: props.isUpdate ? "Update scope" : "Create new scope",
				value: "new",
				onClick: () => null,
			},
		];
		if (!props.isUpdate) {
			_options.push({
				label: "Update existing scope",
				value: "add",
				onClick: () => copy(),
			});
		}

		return _options;
	};

	const [form] = useForm();

	useEffect(() => {
		props.setForm(form);
	}, [form]);

	useEffect(() => {
		if (props.scope && props.isUpdate) {
			form.setFieldValue("name", props.scope.name);
			form.setFieldValue("description", props.scope.description);
		}
	}, [props.scope]);

	const addToExisting = scope => {
		const hide = message.loading("Adding items to scope...", 0, () => {});
		if (mode === "new") {
			if (!Object.keys(scope).includes("type")) {
				scope["type"] = "user-defined";
			}

			const endpoint = props.isUpdate ? "edit" : "add";

			scope["filters"] = props.filters;
			if (props.isUpdate) {
				scope["_id"] = props.scope._id;
			}
			api.post(`/projects/${props.projectId}/scopes/${endpoint}`, scope)
				.then(() => {
					message.success(`The scope ${scope.name} was successfully created`);
					props.onFinish();
				})
				.catch(() => message.error("Something went wrong during saving! Please try again later."))
				.finally(() => setTimeout(hide, 10));
		} else if (mode === "add") {
			api.post(`/projects/${props.projectId}/scopes/add/items?id=${scope._id}`, props.filters)
				.then(() => {
					message.success(`${props.total} items were added to the scope`);
					props.onFinish();
				})
				.catch(() => message.error("Something went wrong"))
				.finally(() => setTimeout(hide, 10));
		}
	};

	const fields = [
		{label: "Scope Name", name: "name", _type: "string", message: "Error", required: true},
		{label: "Scope Description", name: "description", _type: "long_text", message: "Error", required: true},
	];

	const getFieldsByType = () => {
		if (mode === "new") {
			return fields;
		} else {
			return [
				{
					label: "Scope Name",
					name: "_id",
					_type: "select-object",
					message: "Error",
					required: true,
					options: scopes.map((item, i) => ({
						label: item.name,
						value: item._id,
					})),
				},
			];
		}
	};

	return (
		<div style={{margin: 10}}>
			<Descriptions size={"small"} style={{width: "100%", margin: 5}} bordered column={2}>
				<Descriptions.Item labelStyle={{width: "20%"}} label={"Items in current selection"}>
					<Statistic valueStyle={{fontSize: 16}} value={props.total} />
				</Descriptions.Item>
			</Descriptions>

			<Radio.Group style={{width: 700, margin: 5}} onChange={e => setMode(e.target.value)} value={mode}>
				<Space direction="vertical">
					{options().map((item, i) => (
						<Radio onClick={item.onClick} value={item.value}>
							{item.label}
						</Radio>
					))}
					<div>
						{mode === "add" && (
							<DataCard title={"Update criteria in existing scope"}>
								<StandardForm
									otherProps={{style: {width: 700}}}
									form={form}
									initialValues={props.scope}
									onFinish={addToExisting}
									fields={getFieldsByType()}
								/>
							</DataCard>
						)}

						{mode === "new" && (
							<DataCard title={"Create new scope"}>
								<StandardForm
									otherProps={{style: {width: 700}}}
									form={form}
									initialValues={{}}
									onFinish={addToExisting}
									fields={getFieldsByType()}
								/>
							</DataCard>
						)}
					</div>
				</Space>
			</Radio.Group>
		</div>
	);
}

export class CreateScope extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentStep: 0,
			fields: [],
			filters: {
				or: [
					{
						and: [],
					},
				],
			},
			total: 0,
			form: null,
			selectedScopeIdx: 0,
			selectedScope: {criteria: {}},
		};
	}

	componentDidMount() {
		if (this.props.projectId) {
			api.post(`/projects/${this.props.projectId}/materials/count`, {filters: this.state.filters}).then(json => {
				this.setState({total: json.data.total});
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.filters !== this.state.filters) {
			api.post(`/projects/${this.props.projectId}/materials/count`, {filters: this.state.filters}).then(json => {
				this.setState({total: json.data.total});
			});
		}

		if (prevProps.projectId !== this.props.projectId) {
			api.post(`/projects/${this.props.projectId}/materials/count`, {filters: this.state.filters}).then(json => {
				this.setState({total: json.data.total});
			});
		}

		if (prevProps.isModalVisible !== this.props.isModalVisible) {
			let currentStep = 0;
			let scope = {criteria: {}};
			let isUpdate = false;
			if (!this.props.isModalVisible) {
				this.setState({
					currentStep: currentStep,
					fields: [],
					isUpdate: isUpdate,
					filters: {
						or: [
							{
								and: [],
							},
						],
					},
					total: 0,
					form: null,
					selectedScopeIdx: 0,
					selectedScope: scope,
				});
			} else {
				if (this.props.scope) {
					currentStep = 1;
					scope = this.props.scope;
					isUpdate = true;
					this.setState({
						currentStep: currentStep,
						filters: scope.criteria,
						isUpdate: isUpdate,
						selectedScope: scope,
					});
				}
			}
		}
	}

	createScope() {
		this.state.form.submit();
	}

	openNext = action => {
		if (action === "new") {
			this.goToNextStep();
		}
	};

	resetChoice = () => {
        this.setState({
            currentStep: 0,
            fields: [],
            filters: {
                or: [
                    {
                        and: [],
                    },
                ],
            },
            total: 0,
            form: null,
            selectedScopeIdx: 0,
            selectedScope: {criteria: {}},
        });
	};

	getSteps = () => [
		{
			title: "Select mode",
			key: "mode",
			content: (
				<ScopeMode
					openNext={this.openNext}
					projectId={this.props.projectId}
					selected={this.state.selectedScopeIdx}
					resetChoice={this.resetChoice}
					onScopeSelect={(idx, scope) => {
						this.setState({
							selectedScopeIdx: idx,
							selectedScope: scope,
							filters: scope.criteria,
						});
					}}
				/>
			),
		},
		{
			title: "Select Filters",
			key: 0,
			content: (
				<MaterialFilter
					total={this.state.total}
					projectId={this.props.projectId}
					criteria={this.state.selectedScope.criteria}
					filters={this.state.filters}
					onFilterChange={filters => {
						this.setState({filters});
						console.log(filters);
					}}
				/>
			),
		},
		{
			title: "Attach to a Scope",
			key: 1,
			content: (
				<AddToScope
					scope={this.state.selectedScope}
					isUpdate={this.state.isUpdate}
					projectId={this.props.projectId}
					onFinish={() => this.props.setIsModalVisible(false)}
					setForm={form => this.setState({form: form})}
					filters={this.state.filters}
					total={this.state.total}
				/>
			),
		},
	];

	goToNextStep = () => {
		this.setState({currentStep: this.state.currentStep + 1});
	};

	goToPreviousStep = () => {
		this.setState({currentStep: this.state.currentStep - 1});
		if (this.state.currentStep === 1) {
             this.resetChoice();
        }
	};

	closeModal = () => {
		this.props.setIsModalVisible(false);
	};

	render() {
		return (
			<ModalWindow
				modalProps={{width: "80vw", height: "80vh", footer: null}}
				title={"Create new scope"}
				isModalVisible={this.props.isModalVisible}
				onOk={this.closeModal}
				onCancel={this.closeModal}>
				<Steps current={this.state.currentStep} items={this.getSteps()} />
				<div
					style={{
						height: "68vh",
					}}>
					{this.getSteps()[this.state.currentStep].content}
				</div>
				<div className="steps-action">
					{this.state.currentStep > 0 && (
						<Button
							style={{
								margin: "0 8px",
							}}
							onClick={() => this.goToPreviousStep()}>
							Previous
						</Button>
					)}
					{this.state.currentStep < this.getSteps().length - 1 && (
						<Button
							className="float-right"
							type="primary"
							onClick={() => this.goToNextStep()}
							style={{
								margin: "0 8px",
							}}>
							Next
						</Button>
					)}
					{this.state.currentStep === this.getSteps().length - 1 && (
						<Button
							type="primary"
							className="float-right"
							onClick={() => this.createScope()}
							style={{
								margin: "0 8px",
							}}>
							Done
						</Button>
					)}
				</div>
			</ModalWindow>
		);
	}
}
